module.exports = __webpack_public_path__ + "img/l-hd.6ec60487.jpg";